import { UserReportsContent } from "./components/UserReportsContent";

export default function UserReportsPage() {
  // Page title will be set through React Router configuration
  return <UserReportsContent />;
}
